// extracted by mini-css-extract-plugin
export var chip = "_dh-0";
export var filterDropdown = "_dh-5";
export var filterItem = "_dh-6";
export var icon = "_dh-1";
export var removeButton = "_dh-3";
export var removeIcon = "_dh-4";
export var separator = "_dh-2";